export default "__VITE_ASSET__CDNsjX1b__"